( function( $ ) {
	class VacancyPopupControl {
		constructor( section ) {
			this.section = $( section );
			this.sectionId = section.attr( 'id' );
			this.sectionVacanciesData = window[`themeVars_${this.sectionId}`].data;
			this.buttons = this.section.find( '.position-card__button' );
			this.popup = $( '#modal-open-position' );
			this.popupButton = this.popup.find( '.open-position-modal-info__button' );
			this.listeners = [];
			this.currentId = null;
			this.newId = null;
			this.decodeHTML();
			this.addListeners();
		}

		decodeHTML() {
			this.sectionVacanciesData.forEach( ( elem ) => {
				elem.general = decodeURIComponent( elem.general.replace( /\+/g, ' ' ) );

				for ( let i = 0; i < elem.specifications.length; i++ ) {
					let content = elem.specifications[i].specificationContent;
					if ( typeof content !== 'undefined' ) {
						elem.specifications[i].specificationContent = decodeURIComponent( content.replace( /\+/g, ' ' ) ); 
					}
					
				}
			} );
		}

		addListeners() {
			this.buttons.each( ( i, button ) => {
				let $button = $( button );
				let callback = this.openPopup.bind( this );
				$button.on( 'click', callback );
				this.listeners.push( {'elem': $button, 'func': callback} );
			} );
		}

		removeListeners() {
			this.listeners.forEach( ( listener ) => {
				listener['elem'].off( 'click', listener['func'] );
			} );
		}

		openPopup( e ) {
			this.newId = $( e.currentTarget ).attr( 'data-position-id' );
			if ( this.currentId !== this.newId ) {
				this.changePopupContent();
			}
			this.popup.modal( 'show' );
			this.currentId = this.newId;
		}

		changePopupContent() {
			let popupTitle = this.popup.find( '.open-position-modal-info__title h3' );
			let popupGeneral = this.popup.find( '.open-position-modal-info__general' );
			let popupSpecifications = this.popup.find( '.open-position-modal-info__specifications' );
			let data;

			for ( let i = 0; i < this.sectionVacanciesData.length; i++ ) {
				if ( this.newId === this.sectionVacanciesData[i].id ) {
					data = this.sectionVacanciesData[i];
					break;
				}
			}

			popupTitle.empty();
			popupGeneral.empty();
			popupSpecifications.empty();

			popupTitle.append( data.title );
			popupGeneral.append( data.general );
			this.popupButton.attr( 'data-position-id', data.vacancy_id );
			this.popupButton.attr( 'data-position-name', data.title );

			if ( !data.specifications || !data.specifications.length ) {
				popupSpecifications.hide();
			} else {
				popupSpecifications.show();
			}

			data.specifications.forEach( item => {
				let block = this.createSpecificationBlock( item.specificationTitle, item.specificationContent );
				popupSpecifications.append( block );
			} );
		}

		openJobApplicationPopup() {

		}

		createSpecificationBlock( title, content ) {
			let block = '' +
				'<div class="open-position-modal-info__specification">' +
				`<div class="open-position-modal-info__specification-title">${title}</div>` +
				`<div class="open-position-modal-info__specification-content text-content">${content}</div>` +
				'</div>';

			return block;
		}
	}

	function openJobApplication() {
		$( '#modal-open-position .open-position-modal-info__button' ).on( 'click', function( e ) {
			e.preventDefault();
			const $button = $( this );
			const $modalParent = $button.parents( '.modal' );
			const modalTarget = $button.attr( 'data-modal-target' );
			const positionName = $button.attr( 'data-position-name' );

			$( modalTarget ).find( '.vacancy-popup-position-field' ).val( positionName );
			
			$modalParent.modal( 'hide' );

			setTimeout( function() {
				$( modalTarget ).modal( 'show' );
			}, 600 );
		} );
	}

	let initBlock = function( section = false, isAdmin = false ) {
		const $section = section ? $( section ) : $( '.section-open-position' );		

		$section.each( function() {
			const $sectionInstance = $( this );

			const loadSliders = () => {
				$sectionInstance.find( '.js-open-position-slider-v1' ).each( function() {
					const $slider = $( this );
	
					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}
	
					const $swiperSlide = $slider.find( '.swiper-slide' );
					const $swiperNavigation = $slider.siblings( '.section-open-position__header' );
					const $swiperButtonPrev = $swiperNavigation.find( '.swiper-button-prev' );
					const $swiperButtonNext = $swiperNavigation.find( '.swiper-button-next' );
	
					let loop = true;
					let customPagination = false;
					let popupControls;
	
					$swiperButtonPrev.removeClass( 'swiper-button-lock' );
					$swiperButtonPrev.removeAttr( 'disabled' );
					$swiperButtonNext.removeClass( 'swiper-button-lock' );
					$swiperButtonNext.removeAttr( 'disabled' );
	
	
					const prepareSliderSettings = () => {
						if ( $swiperSlide.length <= 1 && window.matchMedia( 'screen and (max-width: 767px)' ).matches ) {
							loop = false;
							customPagination = true;
						} else if ( $swiperSlide.length <= 2 && window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
							loop = false;
							customPagination = true;
						} else if ( $swiperSlide.length <= 4 && window.matchMedia( 'screen and (min-width: 1280px)' ).matches ) {
							loop = false;
							customPagination = true;
						}						
					};

					const loadSlider = () => {
						new Swiper( $slider[0], {
							slidesPerView: 1,
							slidesPerGroup: 1,
							spaceBetween: 0,
							centeredSlides: false,
							loop: loop,
							speed: 400,
							autoHeight: true,
							slideToClickedSlide: false,
							a11y: {
								enabled: false
							},
							simulateTouch: false,
							breakpoints: {
								768: {
									slidesPerView: 2,
									spaceBetween: 20,
								},
								1280: {
									spaceBetween: 20,
									slidesPerView: 4,
								},
							},
							navigation: {
								nextEl: $swiperButtonNext[0],
								prevEl: $swiperButtonPrev[0],
							},
							pagination: {
								el: $swiperNavigation.find( '.swiper-pagination' )[0],
								type: 'fraction',
							},
							on: {
								afterInit: function() {
									window.app.swiperPaginationHelper( $swiperNavigation, true );
		
									if ( customPagination ) {
										$swiperNavigation.find( '.swiper-pagination .swiper-pagination-total' ).text( $swiperSlide.length );
									}
		
									if ( !isAdmin ) {
										popupControls = new VacancyPopupControl( $slider.parents( '.section-open-position' ) );
									}
								},
								beforeDestroy: function() {
									if ( popupControls ) {
										popupControls.removeListeners();
									}
								}
							}
						} );						
					};

					prepareSliderSettings();
					loadSlider();
				} );
	
				$sectionInstance.find( '.js-open-position-slider-v2' ).each( function() {
					const $slider = $( this );
	
					if ( this.swiper ) {
						this.swiper.destroy( true, true );
					}
	
					const $swiperSlide = $slider.find( '.swiper-slide' );
					const $swiperNavigation = $slider.siblings( '.section-open-position__slider-nav' );
					const $swiperButtonPrev = $swiperNavigation.find( '.swiper-button-prev' );
					const $swiperButtonNext = $swiperNavigation.find( '.swiper-button-next' );
	
					let loop = true;
					let customPagination = false;
					let popupControls;
	
					$swiperButtonPrev.removeClass( 'swiper-button-lock' );
					$swiperButtonPrev.removeAttr( 'disabled' );
					$swiperButtonNext.removeClass( 'swiper-button-lock' );
					$swiperButtonNext.removeAttr( 'disabled' );
	
					const prepareSliderSettings = () => {
						if ( $swiperSlide.length <= 1 && window.matchMedia( 'screen and (max-width: 767px)' ).matches ) {
							loop = false;
							customPagination = true;
						} else if ( $swiperSlide.length <= 2 && window.matchMedia( 'screen and (min-width: 768px)' ).matches ) {
							loop = false;
							customPagination = true;
						} else if ( $swiperSlide.length <= 3 && window.matchMedia( 'screen and (min-width: 1025px)' ).matches ) {
							loop = false;
							customPagination = true;
						}
					};

					prepareSliderSettings();
	
					new Swiper( $slider[0], {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetween: 0,
						centeredSlides: false,
						loop: loop,
						speed: 400,
						autoHeight: true,
						slideToClickedSlide: false,
						a11y: {
							enabled: false
						},
						simulateTouch: false,
						breakpoints: {
							768: {
								slidesPerView: 2,
								spaceBetween: 20,
							},
							1025: {
								spaceBetween: 20,
								slidesPerView: 3,
							},
						},
						navigation: {
							nextEl: $swiperButtonNext[0],
							prevEl: $swiperButtonPrev[0],
						},
						pagination: {
							el: $swiperNavigation.find( '.slider-pagination' )[0],
							type: 'fraction',
						},
						on: {
							afterInit: function() {
								window.app.swiperPaginationHelper( $swiperNavigation );
	
								if ( customPagination ) {
									$swiperNavigation.find( '.slider-pagination .swiper-pagination-total' ).text( $swiperSlide.length );
								}
	
								if ( !isAdmin ) {
									popupControls = new VacancyPopupControl( $slider.parents( '.section-open-position' ) );
								}
							},
							beforeDestroy: function() {
								if ( popupControls ) {
									popupControls.removeListeners();
								}
							}
						}
					} );
				} );				
			};

			window.app.loadVendor( 'Swiper', loadSliders );
		} );
	};

	const readyInitBlock = function() {
		initBlock();
		openJobApplication();
	};

	window.app.loadBlock( initBlock, 'section-open-position', '.section-open-position', false, readyInitBlock );
} )( jQuery );